module.exports = __webpack_public_path__ + "img/reticule4.1c5391b5.jpg";